<template>
  <h2 class="content-block">Users</h2>
  <div v-if="loading" class="loading-overlay">
    LOADING...
    <span class="loader"></span>
  </div>
  <div v-else>

  <DxDataGrid class="dx-card wide-card" :data-source="users" :selection="{ mode: 'single' }" :show-borders="true"
    :columns-auto-width="true" :column-min-width="50" :hover-state-enabled="true" :key-expr="areaId"
    :filter-builder="filterBuilder" :filter-value="filterValue" :column-resizing-mode="nextColumn"
    :allow-column-resizing="true" style="max-height: 80vh" :selected-row-keys="selectedItemKeys"
    @selection-changed="onSelectionChanged" @initialized="saveGridInstance" @row-click="dataRowToggle"
    @exporting="onExporting">
    <!-- @selection-changed="onSelectionChanged"  -->
    <DxLoadPanel :enabled="true" />
    <DxColumnChooser :enabled="true" mode="select" />
    <DxFilterRow :visible="true" />
    <DxHeaderFilter :visible="true" />
    <DxScrolling mode="virtual" />
    <DxExport :enabled="true" />
    <DxToolbar>
      <DxItem location="before" template="addRecordTemplate" />
      <DxItem location="after" template="refreshRecordTemplate" />
      <DxItem location="after" template="removeFilterRecordTemplate" />
      <DxItem location="after" name="exportButton" />
      <DxItem location="after" name="columnChooserButton" />
    </DxToolbar>
    <!-- <DxMasterDetail :enabled="false" template="cmdTemplate" /> -->

    <template #addRecordTemplate>
      <DxButton icon="add" @click="newRec" />
    </template>
    <template #refreshRecordTemplate>
      <DxButton icon="refresh" @click="refreshData" />
    </template>
    <template #removeFilterRecordTemplate>
      <DxButton icon="filter" @click="removeFilter" />
    </template>

    <DxColumn data-field="userName" caption="User Login" />
    <DxColumn data-field="firstName" caption="First Name" />
    <DxColumn data-field="surname" caption="Surname" />
    <DxColumn data-field="view" caption="View Config" />
    <!-- <DxColumn caption="Commands" cell-template="cmdTemplate" /> -->

    <!-- <template #cmdTemplate>
      <DxButton class="list-icon" icon="card" @click="gotoUserInfo" hint="User Info"/>
      <DxButton class="list-icon" icon="unselectall" @click="gotoUserGroupMember" hint="Group Membership"/>
    </template> -->
  </DxDataGrid>
  </div>
</template>

<script>
import {
  DxDataGrid,
  DxColumn,
  DxHeaderFilter,
  DxFilterRow,
  DxScrolling,
  DxColumnChooser,
  // DxLookup,
  DxLoadPanel,
  DxToolbar,
  DxItem,
  DxExport
  // DxMasterDetail
} from "devextreme-vue/data-grid";

import { DxButton } from 'devextreme-vue/button';

export default {
  components: {
    DxDataGrid,
    DxColumn,
    DxHeaderFilter,
    DxFilterRow,
    DxScrolling,
    DxColumnChooser,
    // DxLookup,
    DxLoadPanel,
    DxButton,
    DxToolbar,
    DxItem,
    DxExport
    // DxMasterDetail
  },
  created() {
    this.loadPageData();
  },
  data() {
    return {
      loading: true,
      dataGridInstance: null,
      currentUser: null,
      selectedItemKeys: [],
    };
  },
  computed: {
    users() {
      return this.$store.getters["users/getUsers"];
    },
  },
  methods: {
    saveGridInstance: function (e) {
      this.dataGridInstance = e.component;
    },
    dataRowToggle(e) {
      // var key = this.dataGridInstance.getSelectedRowKeys()[0];

      // if (e.component.isRowExpanded(key)) {  
      //     e.component.collapseRow(key);  
      // }  
      // else {  
      //     e.component.expandRow(key);  
      // }  
    },
    newRec() {
      this.$router.push({ name: 'user-single', params: { id: 0 } });
    },
    removeFilter() {
      this.dataGridInstance.clearFilter("row");
    },
    refreshData() {
      this.loadPageData();
    },
    onSelectionChanged({ selectedRowsData }) {
      this.$router.push({ name: 'user-single', params: { id: selectedRowsData[0].userId } });
    },
    // onSelectionChanged(e) {
    //   // e.component.collapseAll(-1);
    //   this.selectedItemKeys = e.selectedRowsData[0].userId;      
    // },
    // gotoUserInfo() {
    //   this.$router.push({ name: 'user-single', params: {id: this.selectedItemKeys }});
    // },
    // gotoUserGroupMember() {
    //   this.$router.push({ name: 'user-group-membership', params: {id: this.selectedItemKeys }});
    // },

    async loadPageData(refresh = false) {
      this.loading = true;
      try {
        await this.$store.dispatch("users/loadUsers", {
          forceRefresh: refresh,
        });
      } catch (error) {
        this.error = error.message || "Unexpected Error.";
      } finally {
        this.loading = false;
      }
    },
    onExporting(e) {
      e.fileName = `UsersDataExport_${new Date().toISOString().slice(0, 10)}`;
    },
  },
};
</script>

<style scoped>
.list-icon {
  margin: 0px 10px 0px 0px;
}
</style>
